import {
  Box,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import AllTable from "../commontable/table";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useState, useCallback, useEffect } from "react";
import { getInvoiceData } from "../../features/invoice/invoiceSlice";

const headerData = [
  { id: 1, title: "Date" },
  { id: 2, title: "Total Amount" },
  // { id: 3, title: "Discount(%)" },
  { id: 4, title: "Discount Amount" },
  { id: 5, title: "Total Payable" },
  { id: 6, title: "Paid" },
  { id: 7, title: "Due(s)" },
  { id: 8, title: "Change Returned" },
];

const secondHeaderData = [
  { id: 1, title: "Batch no." },
  { id: 2, title: "Product Name" },
  { id: 3, title: "QTY Sold" },
  { id: 4, title: "QTY Returned" },
  { id: 5, title: "Rate/Sell Price" },
  { id: 6, title: "Amount" },
];

// const thirdHeaderData = [
//   "Date",
//   "Returned Amount",
//   "Returned Discount Amt(%)",
//   "Returned Discount Amt(RS)",
// ];

const fourHeaderData = [
  { id: 1, title: "Total Amount" },
  { id: 2, title: "Net Paid" },
];

export const SalesHistoryModal = ({ invoiceId, isPagination }: any) => {
  const dispatch = useAppDispatch();
  const [tableRowData, setTableRowData] = useState<any[]>([]);
  const [secTableRowData, setSecTableRowData] = useState<any[]>([]);
  const [thirdTableRowData, setThirdTableRowData] = useState<any[]>([]);
  const [fourTableRowData, setFourTableRowData] = useState<any[]>([]);
  const rowData: any = useAppSelector((state: any) => state?.invoice);
  const pharmacyId = localStorage.getItem("pharmacyId") || "";
  const getInvoice = useCallback(async () => {
    if (invoiceId) {
      const obj = {
        pharmacy_id: pharmacyId,
        invoice_id: invoiceId,
      };
      try {
        const res = await dispatch(getInvoiceData(obj));
        if (res?.payload) {
          setTableRowData(res?.payload?.sales || []);
        }
      } catch (error) {
        console.error("Error fetching invoice data:", error);
      }
    }
  }, [dispatch, invoiceId, pharmacyId]);

  const hasDiscountPercentagePrevious = rowData?.invoiceDetails?.sales?.some(
    (entry: any) => entry.discount_percentage
  );

  const dynamicThirdHeaderData = hasDiscountPercentagePrevious
    ? [
        { id: 1, title: "Date" },
        { id: 2, title: "Returned Amount" },
        { id: 3, title: "Returned Discount Amt(RS)" },
      ]
    : [
        { id: 1, title: "Date" },
        { id: 2, title: "Returned Amount" },
        { id: 3, title: "Returned Discount Amt(%)" },
        { id: 4, title: "Returned Discount Amt(RS)" },
      ];

  useEffect(() => {
    getInvoice();
  }, [getInvoice, invoiceId]); // Call getInvoice whenever invoiceId changes

  const formatDateTime = (dateTimeString: any) => {
    const dateTime = new Date(dateTimeString);
    const date = `${dateTime.getFullYear()}-${(dateTime.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${dateTime.getDate().toString().padStart(2, "0")}`;
    return date;
  };

  useEffect(() => {
    if (
      rowData &&
      rowData?.invoiceDetails &&
      rowData?.invoiceDetails?.sales &&
      rowData?.invoiceDetails?.sales?.length > 0
    ) {
      const newData = [
        {
          Date: formatDateTime(rowData?.invoiceDetails?.invoice_date),
          "Total Amount": rowData?.invoiceDetails?.pre_total_Amount
            ? rowData?.invoiceDetails?.pre_total_Amount?.toLocaleString("en-IN")
            : rowData?.invoiceDetails?.total_Amount?.toLocaleString("en-IN"),
          // "Discount(%)":
          //   rowData?.invoiceDetails?.discount_percentage?.toFixed(2),
          "Discount Amount":
            rowData?.invoiceDetails?.discount_Amount?.toLocaleString("en-IN"),
          "Total Payable": rowData?.invoiceDetails?.pre_after_discount_amount
            ? rowData?.invoiceDetails?.pre_after_discount_amount?.toLocaleString(
                "en-IN"
              )
            : rowData?.invoiceDetails?.after_discount_amount?.toLocaleString(
                "en-IN"
              ),
          Paid: rowData?.invoiceDetails?.pre_paid_amount
            ? rowData?.invoiceDetails?.pre_paid_amount?.toLocaleString("en-IN")
            : rowData?.invoiceDetails?.paid_amount?.toLocaleString("en-IN"),
          "Due(s)":
            rowData?.invoiceDetails?.due_amount?.toLocaleString("en-IN"),
          "Change Returned":
            rowData?.invoiceDetails?.return_amount?.toLocaleString("en-IN"),
        },
      ];

      setTableRowData(newData);
    } else {
      setTableRowData([]); // Initialize as an empty array
    }
  }, [rowData]);

  useEffect(() => {
    if (
      rowData &&
      rowData?.invoiceDetails &&
      rowData?.invoiceDetails?.sales &&
      rowData?.invoiceDetails?.sales?.length > 0
    ) {
      const newDataSec = rowData?.invoiceDetails?.sales?.map((item: any) => ({
        "Batch no.": item?.batch?.batch_no,
        "Product Name": item?.medicine_name,
        "QTY Sold": item?.pre_quantity_sold
          ? item?.total_quantity_sold?.toLocaleString("en-IN")
          : item?.quantity_sold?.toLocaleString("en-IN"),
        "QTY Returned": item?.quantity_return
          ? item?.quantity_return?.toLocaleString("en-IN")
          : "-",
        "Rate/Sell Price": item?.sell_price?.toLocaleString("en-IN"),
        Amount: (item?.quantity_sold * item?.sell_price)?.toLocaleString(
          "en-IN",
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
        ),
      }));

      setSecTableRowData(newDataSec);
    } else {
      setSecTableRowData([]); // Initialize as an empty array
    }
  }, [rowData]);

  useEffect(() => {
    if (
      rowData &&
      rowData?.invoiceDetails &&
      rowData?.invoiceDetails?.sales &&
      rowData?.invoiceDetails?.sales?.length > 0
    ) {
      const newDataThird = [
        {
          Date: formatDateTime(rowData?.invoiceDetails?.return_at),
          "Returned Amount":
            rowData?.invoiceDetails?.med_returned_amount?.toLocaleString(
              "en-IN",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            ),
          "Returned Discount Amt(%)":
            rowData.invoiceDetails?.discount_percentage?.toLocaleString(
              "en-IN",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            ),
          "Returned Discount Amt(RS)":
            rowData.invoiceDetails?.returned_discount_amount?.toLocaleString(
              "en-IN",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            ),
        },
      ];

      setThirdTableRowData(newDataThird);
    } else {
      setThirdTableRowData([]); // Initialize as an empty array
    }
  }, [rowData]);

  useEffect(() => {
    if (
      rowData &&
      rowData?.invoiceDetails &&
      rowData?.invoiceDetails?.sales &&
      rowData?.invoiceDetails?.sales?.length > 0
    ) {
      const newDataFour = [
        {
          "Total Amount":
            rowData?.invoiceDetails?.after_discount_amount?.toLocaleString(
              "en-IN",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            ),
          "Net Paid":
            rowData?.invoiceDetails?.after_discount_amount?.toLocaleString(
              "en-IN",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            ),
        },
      ];

      setFourTableRowData(newDataFour);
    } else {
      setFourTableRowData([]); // Initialize as an empty array
    }
  }, [rowData]);

  const isFourHeader = true;

  return (
    <Box sx={{ mt: 2, width: "100%" }}>
      <Box>
        <Typography variant="h6" gutterBottom>
          Invoice Number : {rowData?.invoiceDetails?.id}
        </Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Sales Invoice
        </Typography>
        <Box sx={{ mt: "25px" }}>
          <AllTable
            headerData={headerData}
            rowData={tableRowData}
            isPagination={isPagination}
          />
        </Box>
      </Box>
      {rowData?.invoiceDetails?.is_return && (
        <>
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" gutterBottom>
              Return Invoice
            </Typography>
            <Box sx={{ mt: "25px" }}>
              <AllTable
                headerData={dynamicThirdHeaderData}
                rowData={thirdTableRowData}
                isPagination={isPagination}
              />
            </Box>
          </Box>
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" gutterBottom>
              After Return Sales Invoice
            </Typography>
            <Box sx={{ mt: "25px" }}>
              <AllTable
                headerData={fourHeaderData}
                rowData={fourTableRowData}
                isFourHeader={isFourHeader} // Pass the boolean prop
                isPagination={isPagination}
              />
            </Box>
          </Box>
        </>
      )}
      <Box sx={{ mt: 4 }}>
        <TableContainer>
          <Table>
            <TableRow>
              <TableCell
                colSpan={8}
                style={{
                  backgroundColor: "#0B2238",
                  color: "#FFFFFF",
                  padding: "10px 20px",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                Purchase Item List
              </TableCell>
            </TableRow>
          </Table>
        </TableContainer>
      </Box>

      <Box sx={{ mt: "15px" }}>
        <AllTable
          headerData={secondHeaderData}
          rowData={secTableRowData}
          isPagination={isPagination}
        />
      </Box>
    </Box>
  );
};
